"use client";
import * as React from "react";
const SvgFileDownloadRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11.262 5.647H9.786V.941A.938.938 0 0 0 8.857 0H5.143a.938.938 0 0 0-.929.941v4.706H2.738c-.827 0-1.244 1.017-.66 1.61l4.263 4.32a.916.916 0 0 0 1.309 0l4.262-4.32c.585-.593.177-1.61-.65-1.61ZM.5 15.06c0 .518.418.941.929.941H12.57a.938.938 0 0 0 .929-.941.938.938 0 0 0-.929-.941H1.43a.938.938 0 0 0-.929.94Z" }));
export {
  SvgFileDownloadRound as default
};
